import React, { Component } from 'react';
import {Redirect}  from 'react-router-dom';
import {Box, Container, Typography,TextField, CircularProgress, Button} from '@material-ui/core';
import adminlogo from '../image/SBS_Logo.png' ;
 class Login extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
             
            email:"",
            password:"",
            show_progress: false,   
            loggedIn: false
        
        };
        this.handleChange = this.handleChange.bind()
        this.login = this.login.bind()
    }
    handleChange = (e) =>{
        this.setState({
            [e.target.name]:e.target.value
        })
    }
    login = () =>{
        let valid_data = true;

        this.state.email_error = null;
        this.state.password_error = null;
        if(this.state.email===""){
            this.state.email_error = "Required!";
            valid_data=false;
        }
        if(this.state.password===""){
            this.state.password_error = "Required!";
            valid_data=false;
        };
        if(valid_data){
            this.state.show_progress = true;
        };

        this.setState({
            update:true,
        });
        const {email, password} = this.state
        if (email === "A" && password === "B" ){
            
            this.setState({
                loggedIn: true
            })
        };
    };

    

    render() { 
        
        if(this.state.loggedIn){
            return <Redirect to = "/Dashboard" />
        }
        
        return (
        <Container maxWidth="xs">
            <Box bgcolor="white"
            boxShadow="2"
            borderRadius="20px"
            textAlign="center"
            p="24px"
            mt="100px"
            >
            <img src={adminlogo} width="100%" borderRadius="20px" alt="logo" />
            <Typography variant="h5" color="textSecondary">
               Login </Typography>
               
                 <TextField
                 label="Email"
                id="outlined-size-normal"
                type="Email"
                name="email"
                value={this.state.email}
                onChange={this.handleChange}
                variant="outlined"
                error={this.state.email_error!=null}
                helperText={this.state.email_error}
                size="small"
                fullWidth
                margin="normal"
                 />
                 <TextField
                 label="Password"
                id="outlined-size-normal"
                type="Password"
                name="password"
                value={this.state.password}
                onChange={this.handleChange}
                variant="outlined"
                error={this.state.password_error!=null}
                helperText={this.state.password_error}
                size="small"
                fullWidth
                margin="normal"
                 />
                 <br/>
                    <br/>
                  {this.state.show_progress?  
                 <CircularProgress size={24} color="secondary" />
                    :null}
                 <br/>
                 <br/>

                <Button 
                disableElevation
                variant="contained" 
                onClick={this.login}
                color="primary"
                fullWidth
                >
                    Login
                </Button>
            </Box>
        </Container>
        );
    }
}

export default Login;
